/** @format */

import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { IonButton, IonNote, IonIcon } from '@ionic/angular/standalone';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { State } from '@app/billing/store/billing.reducer';
import { selectSubscriptionLevelNameTranslateKey } from '@app/billing/store/billing.selectors';

@Component({
    selector: 'fs-subscription-mini-status-edit',
    templateUrl: './subscription-mini-status-edit.component.html',
    styleUrls: ['./subscription-mini-status-edit.component.scss'],
    standalone: true,
    imports: [AsyncPipe, TranslatePipe, IonButton, IonNote, IonIcon]
})
export class SubscriptionMiniStatusEditComponent {
  private store = inject<Store<State>>(Store);

  @Input() color = 'light';
  @Input() showEditButton = true;
  @Input() showPlan = true;
  @Input() isDisabled = false;
  @Input() level = '';
  @Output() clicked = new EventEmitter<Event>();

  // get us eventDate plz

  subscriptionLevel$: Observable<string> = this.store.select(selectSubscriptionLevelNameTranslateKey);
  // .pipe(map((lvl) => this.level || lvl));

  // make sure that the ionic trigger is unique in html
  triggerId = Math.random().toString(36).substring(2);

  get buttonTitleTranslateKey() {
    return this.showPlan ? 'AUTH.PLANS.EDIT_PROFILE_SUBSCRIPTION' : 'STUDIO.EDIT';
  }

  onClick(event) {
    if (!this.isDisabled) {
      this.clicked.emit(event);
    }
  }
}
